import { BooleanField, Datagrid, DateField, List,  NumberField, SelectInput, TextField } from "react-admin";
import { LANGUAGES } from "@/src/services";

const filter = [
    <SelectInput variant="outlined" source="type"
        choices={[
            { id: 'info', name: "Info" },
            { id: 'success', name: "Success" },
            { id: 'warning', name: "Warning" },
            { id: 'error', name: "Error" },
            { id: 'default', name: "Default" },
        ]}
    />,
    <SelectInput variant="outlined" source='language'
        label="UI language"
        helperText={false}
        choices={LANGUAGES} />
]

export const AnnounceList = () => (
    <List
        perPage={25}
        sort={{ field: 'createdAt', order: 'DESC' }}
        filters={filter}
        exporter={false}
    >
        <Datagrid rowClick="edit">
            <BooleanField source="active" />
            <TextField source="type" />
            <TextField source="language" />
            <DateField source="createdAt" />
            <DateField source="updatedAt" />
            <DateField source="startsOn" />
            <DateField source="endsOn" />
            <TextField source="content" />
            <NumberField source="delay" />
        </Datagrid>
    </List>
);

export default AnnounceList;